import React from 'react';

function TimeReadingHeaderRow() {
	return (
		<tr><th>Pag.</th><th>Id</th><th>Tidpunkt</th></tr>
	);
}
export default TimeReadingHeaderRow;